/**
 * Formats a number (or numeric string) with thousands separators, e.g. `12345` -> `"12,345"`.
 * Returns an empty string for `null`/`undefined` input.
 * @param value - The number or numeric string to format
 */
export function addCommas(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "";

  const [integerPart, decimalPart] = String(value).split(".");
  let formattedInteger = integerPart;
  const groupingPattern = /(\d+)(\d{3})/;
  while (groupingPattern.test(formattedInteger)) {
    formattedInteger = formattedInteger.replace(groupingPattern, "$1,$2");
  }

  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}

/**
 * Replaces spaces in a filename with underscores.
 * @param fileName - The filename to sanitize
 */
export function formatFileName(fileName: string): string {
  return fileName.replace(/ /g, "_");
}
